import { lt, useFeatureFlag } from '@mews/framework';
import { PaymentRequestType } from '@mews-commander/data-access';
import { DataTestId, FeatureFlag } from '@mews-commander/enums';
import { WithAccountId } from '@mews-commander/types';
import { Button, IconName } from '@optimus-web/core';
import { ProcessPaymentType } from '../../forms/ProcessPayment/ProcessPaymentType';
import { useProcessPaymentDialog } from '../../forms/ProcessPayment/useProcessPaymentDialog';

export const AddPaymentMethodButton = ({ accountId }: WithAccountId) => {
    const isPaymentRequestCollectTypeEnabled = useFeatureFlag(FeatureFlag.paymentRequestCollectTypeEnabled);

    const [renderProcessPaymentDialog, toggleProcessPaymentDialog] = useProcessPaymentDialog({
        accountId,
        allowedPaymentTypes: [
            ProcessPaymentType.TokenizeCard,
            ProcessPaymentType.RecordCard,
            ...(isPaymentRequestCollectTypeEnabled ? [ProcessPaymentType.PaymentRequest] : []),
        ],
        title: lt('ProcessPaymentPanelTitleForPaymentMethods'),
        paymentMethodCardsOptions: {
            onlyCardsForMultipleMethods: true,
            onlyDescriptionForSingleMethod: true,
        },
        allowedPaymentRequestTypeOptions: isPaymentRequestCollectTypeEnabled
            ? [PaymentRequestType.PaymentMethod]
            : undefined,
    });

    return (
        <>
            <Button
                onClick={toggleProcessPaymentDialog}
                icon={IconName.Add}
                type="submit"
                data-test-id={DataTestId.AddPaymentMethodButton}
            >
                {lt('PaymentMethodTableHeaderActionButtonTitle')}
            </Button>
            {renderProcessPaymentDialog()}
        </>
    );
};
